import React, { useContext, useEffect, useState } from "react";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import useLogics from "./logics";
import { useGET } from "@API2";
import { ReceiverEndpoints, getAllReceivers } from "@RECEIVERS";
import {
  Table,
  Row,
  Col,
  Button,
  Modal,
  message,
  Popconfirm,
  Dropdown,
  Menu,
} from "antd";
import Filters from "./filters";
import {
  AiOutlinePlus,
  AiOutlineCloudUpload,
  AiOutlineFileExcel,
  AiOutlineDownload,
  AiFillDelete,
} from "react-icons/ai";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { deleteSelectedReceivers, deleteAllReceivers } from "@RECEIVERS";

const TableModal = ({
  fieldName,
  form,
  onClose,
  setStep,
  setUpdateValues,
  isReturned,
}) => {
  const { pagination, setPageAndLimit, filters } = useContext(FiltersContext);
  const { info } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const {
    data = [],
    loading: apiLoading,
    error,
    mutate,
  } = useGET(
    `${ReceiverEndpoints.listReceivers}`,
    filters
      ? `?page=${pagination.page}&limit=${pagination.limit}&lastName=${
          filters.lastName ? filters.lastName : ""
        }&firstName=${filters.firstName ? filters.firstName : ""}&phone=${
          filters.phone ? filters.phone : ""
        }`
      : false
  );
  const logics = useLogics({
    onLoading: (val) => setLoading(val),
    mutate,
    fieldName: fieldName,
    form: form,
    onClose: onClose,
    setStep: setStep,
    setUpdateValues: setUpdateValues,
    isReturned: isReturned,
  });

  useEffect(() => {
    if (!apiLoading) {
      setLoading(false);
    }
  }, [apiLoading, data]);
  const handleUseReceiver = (record) => {
    let tempForm = form.getFieldsValue();
    if (isReturned) {
      tempForm.firstName = record.firstName;
      tempForm.lastName = record.lastName;
      tempForm.phone = record.phone;
      tempForm.city = record.address.city?.name;
      tempForm.town = record.address.town?.name;
      tempForm.district = record.address?.district?.name;
      tempForm.addressLine = record.address?.addressLine;
    } else {
      tempForm[fieldName].recipientName = record.firstName;
      tempForm[fieldName].recipientSurname = record.lastName;
      tempForm[fieldName].recipientPhone = record.phone;
      tempForm[fieldName].recipientCity = record.address.city?.name;
      tempForm[fieldName].recipientTown = record.address.town?.name;
      tempForm[fieldName].recipientDistrict = record.address?.district?.name;
      tempForm[fieldName].recipientAddressLine = record.address?.addressLine;
    }
    form.setFieldsValue(tempForm);
    onClose();
  };

  const exportToExcel = () => {
    if (!info.authorities.includes("DOWNLOAD_RECEIVER")) {
      return message.error("Alıcı bilgisi indirme yetkiniz bulunmamaktadır!");
    }
    if (selectedRows.length === 0) return;

    // Türkçe başlıklarla ve schema'ya uygun veri dönüşümü
    const dataToExport = selectedRows.map((row) => ({
      Ad: row.firstName || "",
      Soyad: row.lastName || "",
      "Telefon Numarası": row.phone || "",
      İl: row.address?.city?.name || "",
      İlçe: row.address?.town?.name || "",
      Mahalle: row.address?.district?.name || "",
      "Açık Adres": row.address?.addressLine,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Seçilen Kayıtlar");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "seçili_kisiler.xlsx");
  };

  const exportToExcelAll = async () => {
    try {
      if (!info.authorities.includes("DOWNLOAD_RECEIVER")) {
        return message.error("Alıcı bilgisi indirme yetkiniz bulunmamaktadır!");
      }
      const response = await getAllReceivers(); // API endpointine göre değiştir
      const allData = response || [];

      if (allData.length === 0) return;

      const dataToExport = allData.map((row) => ({
        Ad: row.firstName || "",
        Soyad: row.lastName || "",
        "Telefon Numarası": row.phone || "",
        İl: row.address?.city?.name || "",
        İlçe: row.address?.town?.name || "",
        Mahalle: row.address?.district?.name || "",
        "Açık Adres": row.address?.addressLine,
      }));

      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tüm Kayıtlar");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "tum_kisiler.xlsx");
    } catch (error) {
      console.error("Excel verisi alınamadı:", error);
    }
  };

  const deleteAll = async () => {
    try {
      if (!info.authorities.includes("RECEIVER_DELETE")) {
        return message.error("Kişi silme yetkiniz bulunmamaktadır!");
      }
      setLoading(true);
      const response = await deleteAllReceivers();
      if (response.success) {
        mutate();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteSelected = async () => {
    try {
      if (!info.authorities.includes("RECEIVER_DELETE")) {
        return message.error("Kişi silme yetkiniz bulunmamaktadır!");
      }
      setLoading(true);
      const response = await deleteSelectedReceivers(
        selectedRows.map((x) => {
          return x.id;
        })
      );
      if (response.success) {
        mutate();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="exportAll"
        icon={<AiOutlineDownload style={{ marginRight: 5 }} />}
        onClick={exportToExcelAll}
      >
        Tümünü Excel Olarak İndir
      </Menu.Item>

      <Menu.Item
        key="exportSelected"
        icon={<AiOutlineFileExcel style={{ marginRight: 5 }} />}
        disabled={selectedRowKeys.length === 0}
        onClick={selectedRowKeys.length > 0 ? exportToExcel : undefined}
      >
        Seçilenleri Excel Olarak İndir
      </Menu.Item>

      <Menu.Item
        key="deleteSelected"
        icon={
          <AiFillDelete
            style={{
              marginRight: 5,
              color: selectedRowKeys.length === 0 ? "#999" : "red",
            }}
          />
        }
        disabled={selectedRowKeys.length === 0} // still disables Menu.Item
      >
        <Popconfirm
          title={`${selectedRowKeys.length} kayıt silinecek. Onaylıyor musunuz?`}
          okText="Evet"
          cancelText="Hayır"
          onConfirm={deleteSelected}
          okType="danger"
          disabled={selectedRowKeys.length === 0} // seçim yoksa açılmaz
        >
          <span>Seçilenleri Sil</span>
        </Popconfirm>
      </Menu.Item>

      <Menu.Item
        key="deleteAll"
        icon={<AiFillDelete style={{ marginRight: 5, color: "red" }} />}
      >
        <Popconfirm
          title={`${data?.totalRowCounts} kayıt silinecek. Onaylıyor musunuz?`}
          okText="Evet"
          cancelText="Hayır"
          onConfirm={deleteAll}
          okType="danger"
        >
          <span>Tümünü Sil</span>
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Modal
        visible
        title="Kayıtlı Alıcı Bilgilerim"
        onCancel={onClose}
        width={1350}
        footer={false}
      >
        <Row gutter={24}>
          <Col span={24}>
            <div className="app-content-header">
              <div
                style={{
                  width: "100%",
                  padding: "12px 24px",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <Filters />
                <Button
                  icon={<AiOutlineCloudUpload />}
                  type="primary"
                  onClick={() => {
                    if (!info.authorities.includes("CREATE_RECEIVER")) {
                      return message.error(
                        "Alıcı bilgisi ekleme yetkiniz bulunmamaktadır!"
                      );
                    }
                    setStep("UPLOAD");
                  }}
                >
                  Excel ile Alıcı Yükle
                </Button>
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div className="receiver-page-content">
              <div className="app-deliveries">
                <Row gutter={[12, 12]}>
                  <Col>
                    <Dropdown overlay={menu}>
                      <Button type="primary" style={{ marginBottom: 16 }}>
                        <span>Aksiyonlar </span>
                      </Button>
                    </Dropdown>
                  </Col>
                </Row>

                <Table
                  name="Kayıtlı Alıcı Bilgilerim Listesi"
                  {...logics}
                  dataSource={data?.rows || []}
                  rowKey="id"
                  loading={loading}
                  scroll={{ x: "max-content", y: window.innerHeight - 600 }}
                  mutate={() => mutate()}
                  pagination={{
                    pageSizeOptions: [25, 50, 100, 250],
                    total: data?.totalRowCounts,
                    pageSize: pagination?.limit,
                    current: pagination?.page,
                    onChange: (page, limit) => {
                      setPageAndLimit({ page, limit });
                    },
                    showSizeChanger: true,
                  }}
                  onRow={(record) => {
                    return {
                      onDoubleClick: () => handleUseReceiver(record),
                    };
                  }}
                  rowSelection={{
                    selectedRowKeys,
                    onChange: (selectedKeys, selectedRows) => {
                      setSelectedRowKeys(selectedKeys);
                      setSelectedRows(selectedRows);
                    },
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <div
              style={{
                marginTop: 24,
                marginBottom: 16,
                marginLeft: 50,
                marginRight: 50,
              }}
            >
              <Button
                type="dashed"
                size="large"
                block
                icon={<AiOutlinePlus />}
                onClick={() => {
                  if (!info.authorities.includes("CREATE_RECEIVER")) {
                    return message.error(
                      "Alıcı bilgisi ekleme yetkiniz bulunmamaktadır!"
                    );
                  }
                  setStep("FORM");
                }}
              >
                Yeni Alıcı Bilgisi Ekle
              </Button>
            </div>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default TableModal;
